"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = Large;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _text = require("@mmc/text");
var _large = _interopRequireDefault(require("../../styles/layouts/large.css"));
var _cardContent = _interopRequireDefault(require("../card-content"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var renderOverlayImage = function renderOverlayImage(image, alt) {
  var imageWidth = 960;
  if (image !== ' ') {
    return /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _large["default"].overlayImage,
      src: dataUtils.appendImageTransforms(image, imageWidth),
      alt: alt
    });
  }
  return null;
};
function Large(_ref) {
  var theme = _ref.theme,
    columns = _ref.columns,
    editorialLayout = _ref.editorialLayout,
    disclaimerData = _ref.disclaimerData,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId;
  var renderColumns = function renderColumns(themeStyles, columnsArr) {
    return columnsArr && columnsArr.map(function (column, i) {
      var imagePath = handleNestedProp(column, 'column.image.image');
      var imageWidth = 1080;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: themeStyles['col-xs-12'] + " " + themeStyles['col-sm-6'] + " " + _large["default"].columnWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _large["default"].imageWrapper
      }, imagePath !== ' ' && imagePath !== '' && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _large["default"].image,
        src: dataUtils.appendImageTransforms(imagePath, imageWidth),
        alt: handleNestedProp(column, 'column.image.altText')
      }), renderOverlayImage(handleNestedProp(column, 'column.overlayImage.image'), handleNestedProp(column, 'column.overlayImage.altText'))), /*#__PURE__*/_react["default"].createElement(_cardContent["default"], {
        theme: themeStyles,
        content: column,
        editorialLayout: editorialLayout,
        disclaimerData: disclaimerData,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId
      }));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _large["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-lg-1'] + " " + _large["default"].sidePanel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-lg-10']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _large["default"].innerWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, renderColumns(theme, columns)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-lg-1'] + " " + _large["default"].sidePanel
  })));
}
Large.displayName = 'Large';